export type UserListValue = {
    userId: number, name: string, email: string
} | null;
